module.exports = __webpack_public_path__ + "img/1_027.66705371.jpg";